import { TablePagination, TableContainer, Box, Checkbox, CircularProgress, Container, CssBaseline, FormControlLabel, Grid, Modal, Paper, Table, TableBody, TableCell, TableHead, TableRow, styled, tableCellClasses } from '@mui/material';
import React from 'react'
import { Component } from 'react'
import Constantes from '../php/Constantes';

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

let filasTotales = 0;
const opcionesFilasPorPagina = [5, 10, 25, 50, 100];

class UsuariosEspeciales extends Component {
    constructor(props){
        super(props);
        this.state = {
            //------------------
            pagina: 0,
            filasPorPagina: 5,
            //------------------
            errores: null,
            notificaciones: null,
            loading: false,
            checkAdd: false,
            datosConsulta: [],
            usuario: {
                nombreUsuario: '',
                lugar: '',
                lugarCentral: '',
                numeroFuncionarioAsociado: '',
                nombreFuncionarioAsociado: '',
            },
            busqueda: {
                nombreUsuario: '',
            },
            consultaRealizada: false,
            lugaresTra: [],
            ubicacionesCentral: [],
            numeroNombre: [],
            tipoUsuario: '',
            modificar: false,
            borrar: false,
            datoEspecifico: {},
        }

        this.usuarioAgregar = this.usuarioAgregar.bind(this);
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejarEnvioAgregarJefe = this.manejarEnvioAgregarJefe.bind(this);
        this.manejarCambiosDatosTipoUsuario = this.manejarCambiosDatosTipoUsuario.bind(this);
        this.manejoEnvioConsulta = this.manejoEnvioConsulta.bind(this);
        this.manejarCambioConsulta = this.manejarCambioConsulta.bind(this);
        this.manejarModificar = this.manejarModificar.bind(this);
        this.manejarBorrar = this.manejarBorrar.bind(this);
        this.manejarCambiosDatosMod = this.manejarCambiosDatosMod.bind(this);
        this.manejarEnvioUsuarioAsociado = this.manejarEnvioUsuarioAsociado.bind(this);
    }

    async componentDidMount(){

        const lugar = await fetch(`${Constantes.RUTA_API}/obtener_lugaresTrabajo.php`);
        const datoLugar = await lugar.json();
        this.setState({
            lugaresTra: datoLugar,
        });


        const lugarCentral = await fetch(`${Constantes.RUTA_API}/obtener_ubicacionesCentral.php`);
        const datoLugarCentral = await lugarCentral.json();
        this.setState({
            ubicacionesCentral: datoLugarCentral,
        });

        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombre.php`);
        const datosNumNom = await numNom.json();
        this.setState({
            numeroNombre: datosNumNom,
        });
    }

    handleChangePage = (event, nuevaPagina) => {
        this.setState({ pagina: nuevaPagina });
    };
    
    handleChangeRowsPerPage = (event) => {
        const filasPorPagina = event.target.value === 'all' ? this.state.datosConsulta.length : parseInt(event.target.value, 10);
        this.setState({ filasPorPagina, pagina: 0 });
    };

    render(){
        const { pagina, filasPorPagina } = this.state;
        filasTotales = this.state.datosConsulta.length;
        return (
            <>
                <h3>Usuarios Especiales/Jefes</h3>
                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                {this.state.loading
                ?
                    <div style={{placeItems: 'center'}}>
                        <Box sx={{alignItems: 'center'}}>
                            <CircularProgress/>
                        </Box>
                    </div>
                :
                    null
                }
                <br/>
                {this.state.consultaRealizada || this.state.tipoUsuario !== ''
                ?
                    null
                :
                    <Container>
                        {/*<FormControlLabel label='Agregar Usuario' control={<Checkbox checked={this.state.checkAdd} onChange={this.usuarioAgregar} id='add'  inputProps={{ 'aria-label': 'controlled' }} />  }/>*/}
                    </Container>
                }
                {this.state.checkAdd
                ?
                    this.state.tipoUsuario !== '' && this.state.tipoUsuario === '1'
                    ?
                        <Container>
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Nombre Usuario</StyledTableCell>
                                            <StyledTableCell>Departamento</StyledTableCell>
                                            {this.state.usuario.lugar === '0' ? <StyledTableCell></StyledTableCell> : null}
                                            <StyledTableCell>N. F. Asociado</StyledTableCell>
                                            <StyledTableCell>Nombre</StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <StyledTableRow>
                                            <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='nombreUsuario' value={this.state.usuario.nombreUsuario} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                            <StyledTableCell>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}}  id="lugar" value={this.state.usuario.lugar} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}></option>
                                                    {this.state.lugaresTra.map((name) =>
                                                        <option
                                                        key={name.idLugaresTrabajo}
                                                        value={name.idLugaresTrabajo}
                                                        >{name.lugar}</option>
                                                        )}
                                                </select>
                                            </StyledTableCell>
                                            {this.state.usuario.lugar === '0'
                                            ?
                                                <StyledTableCell>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}}  id="lugarCentral" value={this.state.usuario.lugarCentral} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}>LUGAR CENTRAL</option>
                                                    {this.state.ubicacionesCentral.map((name) =>
                                                        <option
                                                        key={name.idUbicacionesCentral}
                                                        value={name.idUbicacionesCentral}
                                                        >{name.descripcion}</option>
                                                        )}
                                                </select>
                                                </StyledTableCell>
                                            :
                                                null
                                            }
                                            <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroFuncionarioAsociado' value={this.state.usuario.numeroFuncionarioAsociado} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                            <StyledTableCell>{this.state.usuario.nombreFuncionarioAsociado}</StyledTableCell>
                                            <StyledTableCell><button className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarEnvioAgregarJefe}>Agregar</button></StyledTableCell>
                                        </StyledTableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Container>
                    :
                        this.state.tipoUsuario !== '' && this.state.tipoUsuario === '1'
                        ?
                            <Container>

                            </Container>
                        :
                            <Container>
                                <Box sx={{ flexGrow: 1}} >
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={5}>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}}  id="lugar" value={this.state.usuario.lugar} onChange={this.manejarCambiosDatosTipoUsuario}>
                                                <option value={''}></option>
                                                <option value={1}>Funcionarios Jefes Departamento/Sección</option>
                                                <option value={2}>FUncionario Personal(RRHH)</option>
                                            </select>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Container>
                :
                    this.state.consultaRealizada && (!this.state.modificar) && (!this.state.borrar)
                    ?    
                        <Container>
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}} id="tablaConsulta">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell style={{textAlign: 'center'}}>Nombre Usuario</StyledTableCell>
                                            <StyledTableCell style={{textAlign: 'center'}}>Tipo Usuario</StyledTableCell>
                                            <StyledTableCell style={{textAlign: 'center'}}>N. F. Asociado</StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.datosConsulta.slice(this.state.pagina * this.state.filasPorPagina, this.state.pagina * this.state.filasPorPagina + this.state.filasPorPagina).map((name) => (
                                            <StyledTableRow key={name.idUsuarioLogin}>
                                                <StyledTableCell style={{textAlign: 'center'}}>{name.usuarioLogin}</StyledTableCell>
                                                <StyledTableCell style={{textAlign: 'center'}}>{name.nombreFuncionario}</StyledTableCell>
                                                {name.numeroFuncionarioAsociado === 0 ? <StyledTableCell style={{textAlign: 'center'}}> - </StyledTableCell> : <StyledTableCell style={{textAlign: 'center'}}>{name.numeroFuncionarioAsociado}</StyledTableCell>}
                                                {name.tipoUsuario === 2 ? <StyledTableCell></StyledTableCell> : <StyledTableCell><button className="btn btn-outline-primary mx-2" type='button' onClick={() => this.manejarModificar(name)}>Modificar</button></StyledTableCell>}
                                                {/*<StyledTableCell><button className="btn btn-outline-primary mx-2" type='button' onClick={() => this.manejarBorrar(name)}>Borrar</button></StyledTableCell>*/}
                                                <StyledTableCell></StyledTableCell>
                                            </StyledTableRow>
                                        ))
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination rowsPerPageOptions={opcionesFilasPorPagina} component="div" count={filasTotales} rowsPerPage={this.state.filasPorPagina} page={this.state.pagina} onPageChange={this.handleChangePage} onRowsPerPageChange={this.handleChangeRowsPerPage} labelRowsPerPage="Filas por página" SelectProps={{inputProps: {'aria-label': 'Filas por página',}, displayEmpty: true,}}/>
                        </Container>
                    :
                        (!this.state.modificar) && (!this.state.borrar)
                        ?
                            <Container>
                                <form className='formulario1'  onSubmit={this.manejoEnvioConsulta}>
                                    <Box sx={{ flexGrow: 1}} >
                                        <Grid container spacing={2} rowSpacing={1}>
                                            <Grid item xs={2.5}>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Item>Nombre Usuario</Item>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='nombreUsuario' value={this.state.busqueda.nombreUsuario} onChange={this.manejarCambioConsulta} type="text" />
                                            </Grid>
                                            <Grid item xs={1}>
                                                <button className="btn btn-outline-primary mx-2" type='submit'>Buscar</button>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </form>
                            </Container>
                        :
                            this.state.modificar
                            ?
                                <Container>
                                    <Box sx={{ flexGrow: 1}} >
                                        <Grid container spacing={2} rowSpacing={1}>
                                            <Grid item xs={2}>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Usuario</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.datoEspecifico.usuarioLogin}
                                            </Grid>
                                            <Grid item xs={1}>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>N. Funcionario</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.datoEspecifico.nombreFuncionario}
                                            </Grid>
                                            <Grid item xs={1}>
                                            </Grid>
                                            <Grid item xs={2}>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>N. F. Asociado</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroFuncionarioAsociado' value={this.state.datoEspecifico.numeroFuncionarioAsociado} onChange={this.manejarCambiosDatosMod}/>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioUsuarioAsociado}>Confirmar</button>
                                </Container>
                            :
                                this.state.borrar
                                ?
                                    <Container>

                                    </Container>
                                :
                                    null
                }
            </>
        )
    }

    usuarioAgregar(){
        this.setState({
            errores: null,
            notificaciones: null,
        })
        if(this.state.checkAdd){
            this.setState({
                errores: false,
                notificaciones: false,
                checkAdd: false,
            })
        }else{
            this.setState({
                errores: false,
                notificaciones: false,
                checkAdd: true,
            })
        }
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
        });
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const funcionarioActualizado = state.usuario;
            if(clave === 'numeroFuncionarioAsociado'){
                //valor = parseFloat(valor);
                //Tengo que buscar la informacion de ese funcionario
                let aux = true;
                this.state.numeroNombre.map((name) =>
                {if(name.numeroFuncionario === valor){
                    funcionarioActualizado['nombreFuncionarioAsociado'] = name.primerNombre + ' ' + name.primerApellido;
                    aux = false;
                }else if(aux){
                    funcionarioActualizado['nombreFuncionarioAsociado'] = '';
                }
                });
            }
            funcionarioActualizado[clave] = valor;
            return{
                usuario: funcionarioActualizado,
            };
        })
    }

    async manejarEnvioAgregarJefe(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            loading: true,
        });

        //---------------------------------------------------
        const cargaUtil = JSON.stringify([this.state.usuario]);
        const respuesta = await fetch(`${Constantes.RUTA_API}/agregar_usuarioJefe.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();

        this.setState({
            errores: exito[0],
            loading: false,
        })

        if(exito[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: 'Los datos fueron ingresados correctamente!',
            })
        }
    }

    manejarCambiosDatosTipoUsuario(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
        });
        let valor = e.target.value;
        this.setState({
            tipoUsuario: valor,
        })
    }

    async manejoEnvioConsulta(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            loading: true,
        });

        //---------------------------------------------------
        const cargaUtil = JSON.stringify([this.state.busqueda]);
        const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_usuariosLogin.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();

        this.setState({
            errores: exito[0],
            loading: false,
        })

        if(exito[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: null,
                datosConsulta: exito[1],
                consultaRealizada: true,
            })
        }
    }

    manejarCambioConsulta(e){
        this.setState({
            errores: null,
            notificaciones: null,
        });
        const clave = e.target.id;
        let valor = e.target.value;

        this.setState(state => {
            const funcionarioActualizado = state.busqueda;
            funcionarioActualizado[clave] = valor;
            return{
                busqueda: funcionarioActualizado,
            };
        })
    }

    manejarModificar(dato){
        this.setState({
            errores: null,
            notificaciones: null,
            datoEspecifico: dato,
            modificar: true,
            borrar: false,
        })
    }

    manejarBorrar(dato){}

    manejarCambiosDatosMod(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
        });
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const funcionarioActualizado = state.datoEspecifico;
            funcionarioActualizado[clave] = valor;
            return{
                datoEspecifico: funcionarioActualizado,
            };
        })
    }

    async manejarEnvioUsuarioAsociado(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            loading: true,
        });

        //---------------------------------------------------
        const cargaUtil = JSON.stringify([this.state.datoEspecifico, sessionStorage.numeroFuncionarioAsociado]);
        const respuesta = await fetch(`${Constantes.RUTA_API}/modificar_usuarioAsociadoEspecial.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();

        this.setState({
            errores: exito[0],
            loading: false,
        })

        if(exito[0] === 'ok'){
            this.setState({
                errores: false,
                notificaciones: 'Usuario correctamente modificado',
                datoEspecifico: {},
                modificar: false,
            })
        }
    }
}

export default UsuariosEspeciales